import React, { Fragment, useRef, useEffect, useMemo, useState, useLayoutEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
// nodejs library to set properties for components
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import L from 'leaflet';
import { MapContainer, TileLayer, ZoomControl, useMap, GeoJSON } from 'react-leaflet';
import './custom.css';
import 'leaflet/dist/leaflet.css';
import { useStoreState, useStoreActions } from 'easy-peasy';
import createMarker from '../modules/map/functions/marker';
import CustomControl from '../modules/map/CustomControl';
import { useIntl } from '../lang/context/intlContext';
import Button from '../components/CustomButton/Button';
import { FiltroIcon } from '../../assets/icons';
import mapPositioning, { mapAttributes } from '../modules/map/functions/calcMapAttributes';

import shapes from '../modules/map/functions/response.json';

//draw shapes
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import { blueDrawStyle, customDrawStyle, defaultDrawStyle } from '../modules/map/functions/defaultDrawStyle';
import { RegionOptions } from '../modules/map/components/RegionOptions';
import { PersonalVideo } from '@material-ui/icons';
import { MyGeoMan } from '../modules/map/components/MyGeoMan';
import CustomControlLY from '../modules/map/CustomControlLY';
//Functions needed
//todo focus
//todo fouces and view

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  mapMenu: { display: 'flex' },
  mapButtons: {
    paddingTop: theme.spacing(14),
    paddingRight: theme.spacing(8),
  },
  mapViewAll: {
    paddingTop: theme.spacing(14),
    paddingRight: theme.spacing(2),
  },
  mapRegion: {
    paddingTop: theme.spacing(14),
    paddingLeft: theme.spacing(1),
    width: '100%',
  },
  content: {},
}));

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
const validateRegionsPosition = (gjsonRegions) => {
  if (!gjsonRegions.features) return [];
  const regions = gjsonRegions.features;
  return regions
    .filter((item) => {
      const [longitude, latitude] = item.properties.flyTo;
      let isValid = true;
      if (isNaN(latitude) || isNaN(longitude)) {
        isValid = false;
      }
      return isValid;
    })
    .map((item) => ({ latitude: item.properties.flyTo[1], longitude: item.properties.flyTo[0] }));
};
function MapCreateRegion(props) {
  const { onClickFilter, modeMap } = props;
  const { i18 } = useIntl();
  const classes = useStyle();
  // const [viewMode, setViewMode] = useState(false);
  const [actionDraw, setActionDraw] = useState({ action: 'default', payload: null });
  const [showParameters, setShowParameters] = useState(false);
  const [shapeGeoJson, setShapeGeoJson] = useState({ radius: 0 });
  //#region easy peasy
  // const toGridMap = useStoreState((state) => state.regionmap.toGridMap);
  const selectedItem = useStoreState((state) => state.regionmap.selectedItem);
  const focusedAsset = useStoreState((state) => state.regionmap.focusedAsset);
  const isViewAll = useStoreState((state) => state.regionmap.isViewAll);
  const gjsonRegions = useStoreState((state) => state.regionmap.gjsonRegions);
  const actionMap = useStoreState((state) => state.regionmap.actionMap);
  const regionTypes = useStoreState((state) => state.region.types);

  const onViewAll = useStoreActions((actions) => actions.regionmap.onViewAll);
  const onFocus = useStoreActions((actions) => actions.regionmap.onFocus);
  const { clearRegions } = useStoreActions((actions) => actions.region);

  const history = useHistory();

  //#endregion
  // console.info(gjsonRegions);
  // console.log('viewMode', viewMode);
  const validRegions = validateRegionsPosition(gjsonRegions);
  // const assetsOnMap = validRegions.map((item) => createMarker(item, false));
  const mapPos = mapAttributes(validRegions);
  const updateOptions = (payload) => setActionDraw({ action: 'UPDATE_OPTIONS', payload });
  const cancelCreateRegion = () => {
    setActionDraw({ action: 'CANCEL', payload: {} });
    setShowParameters(false);
  };
  return (
    <div id="container" className="contentmap">
      <MapContainer center={[-33.441809, -70.649966]} zoom={15} zoomControl={false} maxZoom={18} scrollWheelZoom={true}>
        <ZoomControl position="bottomright" />
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
        />
        {/* <MyComponent
          {...mapPos}
          actionMap={actionMap}
          gjsonRegions={gjsonRegions}
          countItems={validRegions.length > 0 ? 1 : 0}
          selectedItem={selectedItem}
          isViewAll={isViewAll}
          focusedAsset={focusedAsset}
        /> */}
        <CustomControl modeMap={modeMap}>
          <div className={classes.mapMenu}>
            {/* <div className={classes.mapViewAll}>
              <Button
                // disabled={selectedAsset === undefined}
                color="map"
                size="sm"
                startIcon={<FiltroIcon />}
                onClick={() => onFocus(true)}
              >
                Focus
              </Button>
            </div> */}

            <div className={classes.mapViewAll}>
              <Button
                color="map"
                size="sm"
                startIcon={<FiltroIcon />}
                onClick={() => setActionDraw({ action: 'GET_SHAPES', payload: null })}
              >
                {i18('DONE')}
              </Button>
            </div>
            {/* <div className={classes.mapViewAll}>
              <Button color="map" size="sm" startIcon={<FiltroIcon />} onClick={onClickFilter}>
                Filter
              </Button>
            </div> */}
            <div className={classes.mapButtons}>
              <Button
                color="map"
                size="sm"
                startIcon={<FiltroIcon />}
                onClick={() => {
                  history.push('/home/region/map');
                }}
              >
                {i18('view')}
              </Button>
            </div>
          </div>
        </CustomControl>

        {showParameters && (
          <CustomControlLY modeMap={modeMap} position={'topleft'} showControl={showParameters} shapeGeoJson={shapeGeoJson}>
            <div className={classes.mapRegion}>
              <RegionOptions
                i18={i18}
                onUpdate={updateOptions}
                regionTypes={regionTypes}
                shapeGeoJson={shapeGeoJson}
                cancelCreateRegion={cancelCreateRegion}
                clearRegions={clearRegions}
              />
            </div>
          </CustomControlLY>
        )}
        <MyGeoMan actionDraw={actionDraw} setShowParameters={setShowParameters} setShapeGeoJson={setShapeGeoJson} />
      </MapContainer>
    </div>
  );
}

MapCreateRegion.propTypes = {
  onClickFilter: PropTypes.func,
  modeMap: PropTypes.string,
  // numSelected: PropTypes.number.isRequired,
  // children: PropTypes.object,
};

MapCreateRegion.defaultProps = {
  //icon: null,
};
export default MapCreateRegion;
const onEachFeature = (feature, layer) => {
  // does this feature have a property named popupContent?
  if (feature.properties && feature.properties.name) {
    layer.bindPopup(feature.properties.name + ' ' + feature.properties.description);
  }
};

const setStyles = (feature) => {
  const { fillColor, strokeColor, transparency } = feature.properties;
  return {
    fillColor: fillColor === 'default' ? strokeColor : fillColor, //color relleno
    color: strokeColor, //color de la linea
    opacity: transparency === 'default' ? 0.7 : transparency, //opacidad del color interno (fillColor)
  };
};
const createGeoJsonLayer = (gjsonRegions, map) => {
  return L.geoJSON(gjsonRegions, {
    style: setStyles,
    pointToLayer: (feature, latlng) => {
      if (feature.properties.shape === 'CircleMarker') {
        return new L.Circle(latlng, feature.properties.radius);
      } else return new L.Marker(latlng);
    },
    onEachFeature: onEachFeature,
  }).addTo(map);
};

function MyComponent(props) {
  const [gjsonLayer, setGJSonLayer] = useState(null);
  const { bounds, selectedItem, isViewAll, focusedAsset, countItems, gjsonRegions, shapes, actionMap } = props;
  console.log('mycomponente');
  const map = useMap();
  console.log('actionMap', actionMap);
  // console.log('object', );
  useLayoutEffect(() => {
    map.eachLayer(function (layer) {
      map.removeLayer(layer);
    });
    map.locate({ setView: true });
  }, []);
  useEffect(() => {
    console.log('map compoenente effects');
    if (actionMap === 'reload') {
      //create new gjson layer
      const newLayer = createGeoJsonLayer(gjsonRegions, map);
      const boundsOptions = { paddingBottomRight: L.point(0, 210) };
      map.fitBounds(bounds, boundsOptions);
      setGJSonLayer(newLayer);
    } else console.log('not run effect');
  }, [actionMap, gjsonRegions]);

  // if (!gjsonLayer) {
  //   console.log('RETURN NULL');

  //   return null;
  // }

  if (actionMap === 'remove') {
    if (gjsonLayer) gjsonLayer.remove();
    setGJSonLayer(null);
    return null;
  }
  // if (gjsonRegions && actionMap === 'reload') {
  //   console.log('tenho shapes');
  //   //tengo que remover el layer, y agregarlo nuevamente
  //   if (gjsonLayer) gjsonLayer.remove();
  //   const newLayer = createGeoJsonLayer(gjsonRegions, map);
  //   // gjsonLayer.addData(gjsonRegions);
  //   setGJSonLayer(newLayer);
  // }

  if (countItems === 0) {
    console.log('no items');
    map.locate({ setView: true });
    return null;
  }
  const boundsOptions = { paddingBottomRight: L.point(0, 210) };
  // console.log('selectedItem', selectedItem);
  // console.log('isViewAll', isViewAll);
  const isInBound = true;
  // if (focusedAsset) {
  //   console.info(focusedAsset);
  //   const latLong = { lat: focusedAsset.latitude, lng: focusedAsset.longitude };
  //   isInBound = map.getBounds().contains(latLong);
  //   // console.log('isInBound', isInBound);
  //   // console.log('bounds', map.getBounds().contains());
  // }
  if (isViewAll) {
    map.fitBounds(bounds, boundsOptions);
    console.log('viewAll True');
    // console.log('bound', map.getBounds());
  } else {
    console.log('bounds false');
  }
  if (selectedItem.lat) {
    map.setView(selectedItem, 16);
    // map.flyTo(selectedItem, 16);
    // map.panTo(selectedItem);
  } else {
    console.log('viewitem false');
  }

  if (!isViewAll && !selectedItem.lat && isInBound === false) {
    console.log('bounding focused');
    const latLong = { lat: focusedAsset.latitude, lng: focusedAsset.longitude };
    map.setView(latLong, map.getZoom());
    // map.fitBounds(bounds, boundsOptions);
  }

  return null;
}
